import React, { PropsWithChildren, useMemo } from 'react';
import { Box, SxProps } from '@mui/material';

import { File } from '@peerless/data-access/strapi';
import { formatMediaUrl } from '../utils';

interface Props extends PropsWithChildren {
  image: File | string;
  sx?: SxProps;
}

export const BackgroundImage: React.FC<Props> = ({ image, sx = {}, children }) => {
  const imageUrl = useMemo(() => {
    if (typeof image === 'string') return `url(${image})`;

    return `url(${formatMediaUrl(image)})`;
  }, [image]);

  return (
    <Box
      sx={{
        backgroundImage: imageUrl,
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
